<template lang="html">
  <div class="">
    <div class="page-submenu">
      <div class="page-submenu_left">
        <div class="content-box">
          <left-bar tab='3'></left-bar>
        </div>
      </div>
      <div class="page-submenu_right">
        <div class="content-box">
          <div class="search-content">
              <div class="search-content-fields">
                  <el-form inline>
                    <el-form-item label="角色名称：">
                        <el-input clearable v-model="searchData.roleName"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleSearch()">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button :disabled="selectedData.length <= 0" type="primary" @click="handleBatchDeleteClick()" plain>批量删除</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="handleAddNewClick()">添加</el-button>
                    </el-form-item>
                  </el-form>                
              </div>
          </div>
          <common-crud ref="crud"
            :searchData="searchData"
            :tableData.sync="roleData"
            :addNewOrEditData="addNewOrEditData"
            :crudApi="crudApi"
            :showEditFormTitle="false"
            :beforeSave="beforeSave"
            :selectedDataArray.sync="selectedData"
            addSuccessMessages="添加角色成功"
            editSuccessMessages="编辑角色成功"
            deleteSuccessMessages="删除角色成功"
            deleteBatchSuccessMessages="批量删除角色成功"
          >
            <template slot="result">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column sortable prop="roleCode" label="角色编码">
              </el-table-column>
              <el-table-column sortable prop="roleName" label="角色名称">
              </el-table-column>
              <el-table-column :formatter="formatDateTime2Date" sortable prop="updateTime" label="操作时间">
              </el-table-column>                            
              <el-table-column sortable prop="updateBy" label="操作人">
              </el-table-column>                                          
              <el-table-column fixed="right" label="操作">
                <template slot-scope="scope">
                  <div class="table-column-operate">
                    <el-button type="text" @click="handleEditClick(scope.row)">
                      编辑
                    </el-button>
                    <el-button type="text" @click="handleRolePrivilegeClick(scope.row)">
                      授权
                    </el-button>
                    <el-button type="text" @click="handleDeleteClick(scope.row)">
                      删除
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template slot="customTitle">角色信息</template>
            <template slot="editForm">
               <el-row>
                  <el-col :span="8">
                    <el-form-item required label="角色名称" prop="roleName">
                      <el-input type="text" v-model="addNewOrEditData.roleName" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item required label="角色编码" prop="roleCode">
                      <el-input type="text" v-model="addNewOrEditData.roleCode" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <div class="col-full">
                    <el-form-item label="描述" prop="description">
                      <el-input type="textarea" v-model="addNewOrEditData.description" placeholder="请输入（建议75个字符以内）"></el-input>
                    </el-form-item>
                  </div>
                </el-row>
            </template>
            <template slot="confirmAddNewMessage">
              <div>
                <span>确认添加？</span>
              </div>
            </template>
            <template slot="confirmEditMessage">
              <div>
                <span>确认保存？</span>
              </div>
            </template>
            <template slot="confirmDeleteMessage">
              <div>
                <span>删除角色？</span>
              </div>
            </template>
            <template slot="confirmBatchDeleteMessage">
              <div>
                <span>批量删除角色？</span>
              </div>
            </template>
          </common-crud>
        </div>
      </div>
    </div>
    <el-drawer
      :title="'角色权限配置-'+roleName"
      :visible.sync="rolePrivilegeDrawer"
      direction="rtl"
      size="900px"
    >
        <role-privilege :afterSave="handleAfterSavePrivilege" ref="rolePrivilege" :roleId="roleId"></role-privilege>
    </el-drawer>
  </div>
</template>

<script>
import role from '@/api/sysmanagement/role';
import LeftBar from '../LeftBar';
import RolePrivilege from './roleprivilege';

export default {
  components: {
    LeftBar,
    RolePrivilege
  },
  data() {
    return {
      roleData :[],
      roleName: '',
      roleId: '',
      searchData: {
        roleName:'',
      },
      addNewOrEditData: {
        roleName:'',
        roleCode: '',
        description: ''
      },
      crudApi: role,
      rolePrivilegeDrawer: false,
      selectedData: [],
    }
  },
  methods: {
    formatDateTime2Date(row, column, cellValue, index) {
      return this.$refs['crud'].formatDateTime2Date(row, column, cellValue, index);
    },
    handleSearch() {
      this.$refs['crud'].handleSearch(1);      
    },
    handleAddNewClick() {
      this.$refs['crud'].handleAddNew();
    },
    handleEditClick(item) {      
      this.$refs['crud'].handleEdit(item);
    },
    beforeSave(saveData) {
    },
    handleDeleteClick(item) {
      this.$refs['crud'].handleDelete(item);
    },
    handleBatchDeleteClick() {
      this.$refs['crud'].handleBatchDelete();
    },
    handleRolePrivilegeClick(item) {
      this.roleId  = item.id;
      this.roleName = item.roleName;
      this.rolePrivilegeDrawer = true;

      this.$nextTick(() => this.$refs['rolePrivilege'].refreshRolePrivilege());
    },
    handleAfterSavePrivilege() {
      this.rolePrivilegeDrawer = false;
    },
  },  
  mounted() {    
    this.handleSearch();  
  }
};
</script>

<style lang="less" scoped>
  .search-content {
    display: flex;
    margin-bottom: 22px;

    .search-content-fields {
      width: 800px;
    }
  }
  .operate {
    float: right;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?5066f09c